import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  formControl: {
    display: 'flex',
    marginBottom: theme.spacing(3),
  },
  label: {
    display: 'block',
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  checkbox: {
    padding: 8,
    color: theme.palette.primary.main, 
  }
}));

export default function CheckboxGroup({
  label,
  hint,
  labelStyle = {},
  options,
  value,
  onChange,
  helpText,
  hasError,
  wrapperStyle = {},
  style,
  row,
  setColor,
  size,
  ...props
}) {
  const classes = useStyles();
  const handleChange = (el) => (e) => {
    value = value ? (Array.isArray(value) ? value : [value]) : [];
    if (!e.target.checked) {
      value = value.filter((v) => v !== el.value);
    } else {
      value.push(el.value);
    }
    onChange(value);
  };

  return (
    <FormControl
      error={hasError}
      component="fieldset"
      className={classes.formControl}
      style={style}
      {...props}
    >
      {label && <FormLabel className={classes.label}>{label}</FormLabel>}
      { hint && <Typography style={{ paddingBottom:8 }} color="textSecondary" variant="caption">{hint}</Typography>}
      <FormGroup row={row}>
        {options.map((i) => (
          <FormControlLabel
            key={i.value}
            control={
              <Checkbox
                color={setColor}
                className={classes.checkbox}
                checked={value?.includes(i.value)}
                onChange={handleChange(i)}
                value={i.value}
                size={size}
              />
            }
            label={<Typography color='textSecondary'> {i.label}</Typography>}
          />
        ))}
      </FormGroup>
      <FormHelperText>{helpText}</FormHelperText>
    </FormControl>
  );
}
